var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8,3 C17.5673112,3 19,4.46524991 19,6.27272727 C19,8.08020464 17.5673112,9.54545455 15.8,9.54545455 C14.9111421,9.54545455 14.1069276,9.17481619 13.5270535,8.57641125 L9.28033239,11.1102911 C9.35829278,11.3931794 9.4,11.6916084 9.4,12 C9.4,12.3083916 9.35829278,12.6068206 9.28033239,12.8897089 L13.5289938,15.4215882 C14.1087208,14.8243579 14.912133,14.4545455 15.8,14.4545455 C17.5673112,14.4545455 19,15.9197954 19,17.7272727 C19,19.5347501 17.5673112,21 15.8,21 C14.0326888,21 12.6,19.5347501 12.6,17.7272727 C12.6,17.4174401 12.6420979,17.1176633 12.7207629,16.8335991 L8.47351866,14.3030933 C7.89360149,14.901845 7.08915035,15.2727273 6.2,15.2727273 C4.4326888,15.2727273 3,13.8074774 3,12 C3,10.1925226 4.4326888,8.72727273 6.2,8.72727273 C7.08915035,8.72727273 7.89360149,9.09815498 8.47351866,9.69690666 L12.7196676,7.16243616 C12.6417072,6.87954783 12.6,6.58111887 12.6,6.27272727 C12.6,4.46524991 14.0326888,3 15.8,3 Z M15.8,16.0909091 C15.2400186,16.0909091 14.7472275,16.3851227 14.4613503,16.8306507 C14.4528789,16.8560251 14.4406884,16.8800927 14.4272066,16.9037545 L14.3808452,16.9708347 C14.2653211,17.1970697 14.2,17.4543696 14.2,17.7272727 C14.2,18.6310114 14.9163444,19.3636364 15.8,19.3636364 C16.6836556,19.3636364 17.4,18.6310114 17.4,17.7272727 C17.4,16.823534 16.6836556,16.0909091 15.8,16.0909091 Z M6.2,10.3636364 C5.3163444,10.3636364 4.6,11.0962613 4.6,12 C4.6,12.9037387 5.3163444,13.6363636 6.2,13.6363636 C6.78369529,13.6363636 7.29438917,13.3167038 7.5738446,12.8392175 C7.5752871,12.833296 7.57801279,12.8283985 7.58079342,12.8235182 L7.59042894,12.8102088 C7.72379276,12.5713319 7.8,12.2947678 7.8,12 C7.8,11.7023979 7.72232019,11.4233512 7.58656607,11.182911 L7.57741721,11.1669171 C7.29875585,10.6860361 6.7861915,10.3636364 6.2,10.3636364 Z M15.8,4.63636364 C14.9163444,4.63636364 14.2,5.36898859 14.2,6.27272727 C14.2,6.56830489 14.2766265,6.84557866 14.4106715,7.08490394 C14.4144854,7.08804334 14.4167307,7.09190627 14.4189496,7.09579487 L14.4249617,7.10990186 C14.704155,7.5885191 15.2154726,7.90909091 15.8,7.90909091 C16.6836556,7.90909091 17.4,7.17646595 17.4,6.27272727 C17.4,5.36898859 16.6836556,4.63636364 15.8,4.63636364 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/share",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e522cfb9116f967e1b3cc37c3a6204c3.svg";
export { ForwardRef as ReactComponent };